import React from 'react';
import FormWarehouseContact from '../../components/Forms/FormWarehouseContact';
import Permission from '../../components/Permission';
import MetaTitle from '../../components/MetaTitle';
import Modal from '../../components/Modal';
import useFetch from '../../hooks/useFetch';
import Table from '../../components/Table';
import { Animation, Button } from '../../assets/global/globalStyles';
import { ContainerModal, Button as ButtonCreate } from './styles';
import { fetchWarehouses } from '../../store/warehouses';
import { fetchWarehouse, httpRequestWarehouse } from '../../store/warehouse';
import { useSelector, useDispatch } from 'react-redux';
import { AddBoxOutlined } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { deleteWarehouse } from '../../utils/httpRequest';
import USER_GROUPS from '../../global/variables/userGroups';
import USER_ROLES from '../../global/variables/userRoles';

export default function Warehouse() {
  const [modalDetails, setModalDetails] = React.useState(false);
  const { data: contacts } = useSelector((state) => state.warehouse);
  const dispatch = useDispatch();
  const [toggle, setToggle] = React.useState(false);
  const [id, setId] = React.useState(null);
  const navigate = useNavigate();

  const { data: warehouses } = useFetch(
    fetchWarehouses({
      url: '/warehouse/warehouse',
      method: 'GET',
    }),
    'warehouses',
  );

  async function SeeDetails(data) {
    await dispatch(
      fetchWarehouse({
        url: `/warehouse/contacts?warehouseId=${data.id}`,
        method: 'GET',
      }),
    );
    setModalDetails(true);
  }

  function createContact(data) {
    setId(data.id);
    setToggle(true);
  }

  const editWarehouse = (id) => navigate(`/dashboard/editwarehouse/${id}`);

  const exclude = async (data) => {
    const confirmSim = window.confirm('Deseja deletar este depósito?');
    if (confirmSim) {
      const { success } = await dispatch(
        httpRequestWarehouse(deleteWarehouse(data.id)),
      );
      if (success)
        await dispatch(
          fetchWarehouses({
            url: '/warehouse/warehouse',
            method: 'GET',
          }),
        );
    }
  };

  return (
    <>
      <MetaTitle title="Depósitos" />
      <Animation>
        <Permission
          roles={[USER_ROLES.Administrador]}
          groups={[USER_GROUPS.DHL]}
          component={() => (
            <ButtonCreate to="/dashboard/createwarehouse">
              <AddBoxOutlined style={{ width: '25px', height: '25px' }} />
              Adicionar Depósitos
            </ButtonCreate>
          )}
        />
        <Table
          data={warehouses}
          title="Gerenciamento de Depósitos"
          keyStorage="warehouse_filter"
          columnNames={['Código do depósito', 'Nome', 'Endereço']}
          columns={['warehouseCode', 'name', 'address']}
          columnButtons={[
            (data) => (
              <Button typeName="welcome" onClick={() => SeeDetails(data)}>
                Ver contato
              </Button>
            ),
            (data) => (
              <Permission
                roles={[USER_ROLES.Administrador]}
                groups={[USER_GROUPS.DHL]}
                component={() => (
                  <Button
                    typeName="success"
                    onClick={() => createContact(data)}
                  >
                    Adicionar contato
                  </Button>
                )}
              />
            ),
            ({ id }) => (
              <Permission
                roles={[USER_ROLES.Administrador]}
                groups={[USER_GROUPS.DHL]}
                component={() => (
                  <Button typeName="warning" onClick={() => editWarehouse(id)}>
                    Editar
                  </Button>
                )}
              />
            ),
            (data) => (
              <Permission
                roles={[USER_ROLES.Administrador]}
                groups={[USER_GROUPS.DHL]}
                component={() => (
                  <Button typeName="danger" onClick={() => exclude(data)}>
                    Deletar
                  </Button>
                )}
              />
            ),
          ]}
        />
      </Animation>
      <Modal
        open={modalDetails}
        openModal={() => setModalDetails(!modalDetails)}
      >
        <ContainerModal>
          <Table
            data={contacts}
            title="Contato do Depósito"
            keyStorage="warehouse_filter"
            columnNames={['Nome', 'Email', 'Telefone']}
            columns={['contactName', 'email', 'phone']}
          />
        </ContainerModal>
      </Modal>
      <Permission
        roles={[USER_ROLES.Administrador]}
        groups={[USER_GROUPS.DHL]}
        component={() => (
          <Modal
            open={toggle}
            openModal={() => {
              setToggle(!toggle);
              setId(null);
            }}
          >
            <ContainerModal>
              <FormWarehouseContact id={id} closeModal={setToggle} />
            </ContainerModal>
          </Modal>
        )}
      />
    </>
  );
}
